import { render, staticRenderFns } from "./import-products-index.vue?vue&type=template&id=6113753c&"
import script from "./import-products-index.vue?vue&type=script&lang=js&"
export * from "./import-products-index.vue?vue&type=script&lang=js&"
import style0 from "./import-products-index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports